import React, { Component } from "react";
import DonutPMDecisionsPlacement from "./charts/DonutPMDecisionsPlacement";
import ModalPMDecisionsPlacement from "../../../containers/modal/ModalPMDecisionsPlacement";
import PromoSpendTextMasking from "../../promo-spend/PromoSpendTextMasking";
import FontAwesome from "react-fontawesome";
import { deleteRequest } from "../../../api/ApiService";
import { hexToRgba, logError } from "../../../services/utils";
import { decrementUnacceptedDecisions } from "../../../api/SubmitDecisions";
import Styled from "components/pm/style";
import Teams from "api/Teams";
import AbbreviateNumber from "../../ui-building-blocks/numbers/AbbreviateNumber";
import { view } from "@risingstack/react-easy-state";

class PMDecisionsPlacement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      products: props.products,
      sales: props.sales,
      products_prepared: {}
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.products !== nextProps.products ||
      this.state.sales !== nextProps.sales
    ) {
      this.setState(
        {
          products: nextProps.products,
          sales: nextProps.sales
        },
        () => {
          this.prepareData();
        }
      );
    }
  }

  componentDidMount() {
    this.prepareData();
  }

  prepareData() {
    let products_prepared = {};

    this.state.products.forEach(item => {
      products_prepared[item.id] = {
        name: item.name,
        client: 0,
        total: 0,
        sale_id: 0,
        player: null
      };
    });

    this.state.sales.forEach(item => {
      if (item.product in products_prepared) {
        products_prepared[item.product].client = item.client;
        products_prepared[item.product].total = item.total;
        products_prepared[item.product].sale_id = item.id;
        products_prepared[item.product].player = item.player;
      }
    });

    this.setState({
      products_prepared
    });
  }

  onRemoveSales = (e, object_id) => {
    e.preventDefault();

    const { products_prepared } = this.state;
    const products = Object.values(products_prepared);
    const product = products.find(i => i.sale_id === object_id);

    this.removeSalesRequest(object_id)
      .then(res => {
        this.props.showSuccessMessage(`Sales decision set for product ${product.name} was successfully deleted`);
        decrementUnacceptedDecisions("marketing");
        this.props.reloadData();
        this.props.getSubmissionData();
      })
      .catch(err => {
        logError(err, "PMDecisionsPlacement", "onRemoveSales");
      });
  };

  removeSalesRequest(object_id) {
    return deleteRequest(
      `${process.env.REACT_APP_API_URL}team/sales/${object_id}/`
    );
  }

  get sumOfDirectSalesSpend() {
    return this.calculateSum(
      this.props.sales,
      this.props.sales_clients["Direct Sales"],
      "total"
    );
  }

  get sumOfDistributorsSpend() {
    return this.calculateSum(
      this.props.sales,
      this.props.sales_clients["Distributors"],
      "total"
    );
  }

  get total() {
    return - this.sumOfDirectSalesSpend - this.sumOfDistributorsSpend;
  }

  get sumOfCashReceiptsPriorRoundSales() {
    const { accountsReceivable } = this.props;

    return accountsReceivable;
  }

  calculateSum(data, type, key) {
    let sum = 0;
    let l = data.length;

    for (let i = 0; i < l; i += 1) {
      if (data[i].player !== null && data[i].client === type) {
        sum += data[i][key];
      }
    }

    return sum;
  }

  render() {
    return (
      <Styled.WhiteBlockColumn>
        <div>
          <Styled.P.Title>Place</Styled.P.Title>
          <ModalPMDecisionsPlacement
            reloadData={this.props.reloadData}
            products={this.state.products_prepared}
            price_forecasts={this.props.price_forecasts}
            sales_clients={this.props.sales_clients}
            hasAccess={this.props.hasAccess}
            showRoleAlert={this.props.showRoleAlert}
            countOfProducts={this.props.countOfProducts}
            tourMode={this.props.tourMode}
            getSubmissionData={this.props.getSubmissionData}
            showSuccessMessage={this.props.showSuccessMessage}
          />
        </div>

        <Styled.P.Amount>
          <AbbreviateNumber value={this.total} />
        </Styled.P.Amount>

        <DonutPMDecisionsPlacement
          products={this.state.products_prepared}
          sales_clients={this.props.sales_clients}
        />

        <Styled.P.Table
          rowColor={hexToRgba(Teams.currentTeamColorLevel1(), 0.3)}
        >
          <table>
            <thead>
              <tr>
                <th>Product</th>
                <th>Sales Channel</th>
                <th>Total</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {Object.keys(this.state.products_prepared).map(product_id => {
                let product = this.state.products_prepared[product_id];
                let can_remove = product.player !== null ? true : false;
                if (this.props.actionsAllowed === false) {
                  can_remove = false;
                }

                return (
                  <tr key={product_id}>
                    <td>{product.name}</td>
                    <td>
                      {product.client ===
                      this.props.sales_clients["Direct Sales"]
                        ? "Direct Sales"
                        : product.client ===
                          this.props.sales_clients["Distributors"]
                        ? "Distributors"
                        : ""}
                    </td>
                    <td>
                      <PromoSpendTextMasking value={product.total} />
                    </td>
                    <td>
                      {can_remove === true && (
                        <a
                          href="/#"
                          className="remove-operation"
                          onClick={e => this.onRemoveSales(e, product.sale_id)}
                        >
                          <FontAwesome name="trash-o" />
                        </a>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Styled.P.Table>
      </Styled.WhiteBlockColumn>
    );
  }
}

export default view(PMDecisionsPlacement);



// WEBPACK FOOTER //
// ./src/components/pm/decisions/PMDecisionsPlacement.js